import module from 'guest/module.js'

const schema = {}

class GuestInformacionContactoService {
  constructor ($http) {
    this.$http = $http
  }

  get (idProyecto, idColaborador) {
    return this.$http.get('/kendu/kardex/info/contacto', {
      params: {
        idEmpresa: idProyecto,
        idEmpleado: idColaborador,
      },
      schema,
      cache: 'guest',
    })
  }
}

module.service('GuestInformacionContacto', GuestInformacionContactoService)



// WEBPACK FOOTER //
// ./src/guest/services/Guest/Informacion/Contacto.js